import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IBookAccessHistoryVm } from '../book-access-history-vm.model';
import { IBookAccessPackageUm } from '../book-access-package-um.model';
@Injectable({ providedIn: 'root' })
export class BookAccessDetailsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/BookAccessDetails`;
  }
  get(packageGuid: string): Observable<IBookAccessHistoryVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (packageGuid !== undefined && packageGuid !== null) {
      params = params.set('packageGuid', packageGuid.toString());
    }
    return this.http.get<IBookAccessHistoryVm>(this.baseUrl, { headers, params });
  }
  put(bookAccessPackageUm: IBookAccessPackageUm): Observable<IBookAccessHistoryVm> {
    const headers = this.createHeaders();
    return this.http.put<IBookAccessHistoryVm>(this.baseUrl, bookAccessPackageUm, { headers });
  }
  delete(packageGuid: string): Observable<IBookAccessHistoryVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (packageGuid !== undefined && packageGuid !== null) {
      params = params.set('packageGuid', packageGuid.toString());
    }
    return this.http.delete<IBookAccessHistoryVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
